module.exports = __webpack_public_path__ + "static/media/project-image-3-big.5bb94943.png";